export class DashboardEntity {
    visualizations = [];
    constructor(props) {
        this.props = props;
    }

    static restore(props) {
        return new DashboardEntity(props);
    }

    setVisualizations(visualizations) {
        this.visualizations = visualizations;
    }

    getVisualizations() {
        return this.visualizations;
    }
}
